<template>
  <div class="container">
    <el-card>
      <div class="filter-container">
        <span class="search-label">自定义检索：</span>
        <el-select size="small" v-model="currentFilter" style="width: 120px; margin-right: 10px;">
          <el-option v-for="item in filterOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        
        <filters 
          :currentFilter="currentFilter" 
          :frequencyTypeList="frequencyTypeList"
          v-model="paramsValue" 
        />
        
        <el-button size="small" @click="search" style="margin-left: 10px">搜索</el-button>
        <el-button size="small" @click="showall" style="margin-right: auto">全部</el-button>
        
        <el-button size="small" style="margin-left: 10px" type="primary" plain @click="add">添加产品</el-button>
      </div>
    </el-card>
    
    <el-card style="margin-top: 15px">
      <el-table 
        border 
        size="small" 
        :data="tableData && tableData.rows"
        :header-cell-style="{ backgroundColor: '#f7f7f7', color: '#333' }"
        v-loading="loading"
      >
        <el-table-column show-overflow-tooltip align="center" width="180" label="产品ID" prop="id" />
        <el-table-column show-overflow-tooltip align="center" width="180" label="产品名称" prop="name" />
        <el-table-column show-overflow-tooltip align="center" width="120" label="产品别名" prop="alias" />
        <el-table-column show-overflow-tooltip align="center" width="120" label="产品曾用名" prop="old_name" />
        <el-table-column show-overflow-tooltip align="center" width="120" label="保司对账函产品名称" prop="insurer_bill_product_name" />
        <el-table-column show-overflow-tooltip align="center" width="120" label="产品版本" prop="version" />
        <el-table-column show-overflow-tooltip align="center" width="200" label="产品类别" prop="frequency_type" :formatter="formatFrequencyType" />
        <el-table-column show-overflow-tooltip align="center" width="140" label="状态" prop="disabled" :formatter="formatStatus" />
        <el-table-column show-overflow-tooltip align="center" label="备注" prop="note" />
        
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="view(row)">查看</el-button>
            <el-button size="mini" @click="edit(row)">编辑</el-button>
            <el-button 
              v-if="row.disabled" 
              size="mini" 
              type="success" 
              @click="toggleStatus(row, false)"
            >
              启用
            </el-button>
            <el-button 
              v-else 
              size="mini" 
              type="warning" 
              @click="toggleStatus(row, true)"
            >
              禁用
            </el-button>
            <el-button 
              v-if="row.disabled" 
              size="mini" 
              type="danger" 
              @click="deleteProduct(row)"
            >
              删除
            </el-button>
            <el-button 
              v-else 
              size="mini" 
              type="info" 
              disabled
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <pagination 
        :total="tableData && tableData.total" 
        :page.sync="page" 
        :rows.sync="rows"
        @pagination="handleGetList" 
      />
    </el-card>
    
    <!-- 添加/编辑产品对话框 -->
    <el-dialog 
      center 
      append-to-body 
      modal-append-to-body 
      :title="dialogTitle" 
      width="60%" 
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form 
        size="small" 
        label-position="left" 
        label-width="150px" 
        ref="formData" 
        :model="formData" 
        :rules="formRules"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品名称：" prop="name">
              <el-input v-model="formData.name" :disabled="isView" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品别名：" prop="alias">
              <el-input v-model="formData.alias" :disabled="isView" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="产品曾用名：" prop="old_name">
              <el-input v-model="formData.old_name" :disabled="isView" placeholder="多个曾用名请用英文逗号隔开，如：张三,李四" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品版本：" prop="version">
              <el-input v-model="formData.version" :disabled="isView" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品类别：" prop="frequency_type">
              <el-select v-model="formData.frequency_type" style="width: 100%" :disabled="isView">
                <el-option 
                  v-for="item in frequencyTypeList.filter(item => item.id !== 0)" 
                  :key="item.id" 
                  :label="item.text" 
                  :value="item.id" 
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="保司对账函产品名称：" prop="insurer_bill_product_name">
          <el-input v-model="formData.insurer_bill_product_name" :disabled="isView" />
        </el-form-item>
        
        <el-form-item label="备注：" prop="note">
          <el-input 
            type="textarea" 
            v-model="formData.note" 
            :rows="3" 
            maxlength="200" 
            show-word-limit
            :disabled="isView"
          />
        </el-form-item>
      </el-form>
      
      <div slot="footer" v-if="!isView">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save" :loading="saveLoading">确认</el-button>
      </div>
      <div slot="footer" v-else>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "@/components/Pagination";
import filters from "./filters";

export default {
  name: 'ProductBasicConfig',
  components: {
    pagination,
    filters
  },
  data() {
    return {
      page: 1,
      rows: 15,
      loading: false,
      saveLoading: false,
      fileLoading: false,
      submitLoading: false,
      tableData: null,
      currentFilter: 1,
      paramsValue: '',
      
      filterOptions: [
        { value: 1, label: '产品名称' },
        { value: 2, label: '产品类别' }
      ],
      
      frequencyTypeList: [],
      
      dialogVisible: false,
      dialogTitle: '',
      isView: false,
      formData: {
        id: null,
        name: '',
        alias: '',
        old_name: '',
        version: '',
        frequency_type: '',
        insurer_bill_product_name: '',
        note: ''
      },
      
      formRules: {
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        frequency_type: [
          { required: true, message: '请选择产品类别', trigger: 'change' }
        ]
      }
    }
  },
  
  watch: {
    currentFilter() {
      this.paramsValue = '';
    }
  },
  
  async created() {
    await this.initData();
    await this.handleGetList();
  },
  
  methods: {
    async initData() {
      // 初始化产品类别数据
      const productData = this.$store.state.product.productData;
      this.frequencyTypeList = productData.frequency_type;
    },
    
    // 格式化产品类别
    formatFrequencyType(row, column, cellValue) {
      const item = this.frequencyTypeList.find(item => item.id === cellValue);
      return item ? item.text : '未知';
    },
    
    // 格式化状态
    formatStatus(row, column, cellValue) {
      return cellValue ? '禁用' : '正常';
    },
    
    // 获取列表数据
    async handleGetList(params) {
      this.loading = true;
      try {
        let { page, rows, paramsValue, currentFilter } = this.$data;
        let data = { page, rows };
        
        if (paramsValue) {
          if (currentFilter === 1) {
            data.name = paramsValue;
          } else if (currentFilter === 2) {
            data.frequency_type = paramsValue;
          }
        }
        
        params && Object.assign(data, params);
        
        const res = await this.$store.dispatch('product/getProductList', data);
        if (res && res.err_code === 0) {
          this.tableData = res;
        }
      } catch (error) {
        console.error('获取产品列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 搜索
    async search() {
      this.page = 1;
      await this.handleGetList();
    },
    
    // 显示全部
    async showall() {
      this.paramsValue = '';
      this.currentFilter = 1;
      this.page = 1;
      await this.handleGetList();
    },
    
    // 添加产品
    add() {
      this.dialogTitle = '添加产品';
      this.isView = false;
      this.dialogVisible = true;
      this.resetForm();
    },
    
    // 查看产品
    view(row) {
      this.dialogTitle = '查看产品';
      this.isView = true;
      this.dialogVisible = true;
      this.fillForm(row);
    },
    
    // 编辑产品
    edit(row) {
      this.dialogTitle = '编辑产品';
      this.isView = false;
      this.dialogVisible = true;
      this.fillForm(row);
    },
    
    // 重置表单
    resetForm() {
      this.formData = {
        id: null,
        name: '',
        alias: '',
        old_name: '',
        version: '',
        frequency_type: '',
        insurer_bill_product_name: '',
        note: ''
      };
      this.$nextTick(() => {
        this.$refs.formData && this.$refs.formData.clearValidate();
      });
    },
    
    // 填充表单
    fillForm(row) {
      this.formData = {
        id: row.id,
        name: row.name || '',
        alias: row.alias || '',
        old_name: row.old_name || '',
        version: row.version || '',
        frequency_type: row.frequency_type || '',
        insurer_bill_product_name: row.insurer_bill_product_name || '',
        note: row.note || ''
      };
    },
    
    // 保存
    async save() {
      try {
        const valid = await this.$refs.formData.validate();
        if (!valid) return;
        
        this.saveLoading = true;
        
        let res;
        if (this.formData.id) {
          // 编辑
          res = await this.$store.dispatch('product/updateProduct', this.formData);
        } else {
          // 添加
          res = await this.$store.dispatch('product/addProduct', this.formData);
        }
        
        if (res && res.err_code === 0) {
          this.$message.success(this.formData.id ? '更新成功' : '添加成功');
          this.dialogVisible = false;
          await this.handleGetList();
        }
      } catch (error) {
        console.error('保存失败:', error);
      } finally {
        this.saveLoading = false;
      }
    },
    
    // 切换状态
    async toggleStatus(row, disabled) {
      const action = disabled ? '禁用' : '启用';
      
      try {
        await this.$confirm(`您确认要${action}该产品吗？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const res = await this.$store.dispatch('product/disableProduct', {
          id: row.id,
          disabled
        });
        
        if (res && res.err_code === 0) {
          this.$message.success(`${action}成功`);
          await this.handleGetList();
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error(`${action}失败:`, error);
        }
      }
    },
    
    // 删除产品
    async deleteProduct(row) {
      try {
        await this.$confirm('您确认要删除该产品吗？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const res = await this.$store.dispatch('product/deleteProduct', {
          id: row.id
        });
        
        if (res && res.err_code === 0) {
          this.$message.success('删除成功');
          await this.handleGetList();
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .filter-container {
    display: flex;
    align-items: center;
    
    .search-label {
      margin-right: 10px;
      font-weight: 500;
    }
  }
}
</style>